module.exports = __webpack_public_path__ + "static/media/v1.72548df2.jpg";